import "./content.css";
import Header from "../../components/layout/Header/Header";
import SideMenu from "../../components/layout/SideMenu/SideMenu";
import { Navigate, Outlet } from "react-router-dom";
import { useAuthenticate } from "../../hooks";
import { CREATE_ORG_PATH } from "../../router/RouteConstants";

const PageLayout = () => {
    const { auth, ...rest } = useAuthenticate();

    const { accountInfo } = rest ?? {};
    const { account } = accountInfo ?? {};
    const { userId } = account ?? {};

    if (!userId) {
        return <Navigate to={CREATE_ORG_PATH} />;
    }

    return (
        <div className="page-layout">
            {/* {isPending && <AIEduSpinner />} */}
            <Header />
            <main className="sidepanel-body">
                <SideMenu />
                <div className="content">
                    <Outlet />
                </div>
            </main>
        </div>
    );
};

export default PageLayout;
